import React, { useEffect, useState } from "react";
import Notification from "../../../elements/notification/Notification";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import RatesDetailsInfo from "./RatesDetailsInfo";
import RatesEditService from "./RatesEditService";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledFeeDetailsWrapper } from "../../../fee/styledFee";
import GoToBackButton from "../../../elements/goToBack/GoToBack";
import { useHistory } from "react-router-dom";
import { StyledFormGrid } from "../../../styles/styledTabsForm";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";

const RatesDetailsContainer = ({ match }) => {
  const history = useHistory();

  const [rate, setRate] = useState();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get("/api/rates/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setRate(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <StyledFeeDetailsWrapper>
          <GoToBackButton
            handler={() => {history.goBack();}}
            pt="20"
            pb="30"
          />
          <StyledFormGrid>
            <RatesDetailsInfo
              rate={rate}
            />
            <RatesEditService
              rate={rate}
              setRate={setRate}
              notification={notification}
              setNotification={setNotification}
            />
          </StyledFormGrid>
        </StyledFeeDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default RatesDetailsContainer;